import { Link } from "react-router-dom";
import type { Work } from "@/mocks/works";
import { formatViews, workFormat } from "@/mocks";

interface Props {
  work: Work;
}

export default function WorkCard({ work }: Props) {
  return (
    <Link
      to={`/detail/${work.id}`}
      className="group block cursor-pointer overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-colors duration-300 hover:border-primary-300"
      data-product-shop
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={work.poster}
          alt={`${work.title} 海报`}
          title={`${work.title} 剧情介绍`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-x-0 bottom-0 h-2/5 bg-gradient-to-t from-foreground-950/80 to-transparent" />
        <span className="absolute left-3 top-3 rounded bg-background-50/95 px-2 py-0.5 text-[11px] font-medium text-primary-700">
          {workFormat(work.type)}
        </span>
        <span className="absolute right-3 top-3 flex items-center gap-1 rounded bg-accent-500 px-2 py-0.5 text-[11px] font-bold text-background-50">
          <i className="ri-star-fill text-[10px] leading-none" />
          {work.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 flex items-center justify-between px-3 pb-2.5 text-[11px] text-background-100">
          <span className="whitespace-nowrap">{work.year} · {work.region}</span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-eye-line text-[11px] leading-none" />
            {formatViews(work.views)}
          </span>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="line-clamp-2 font-heading text-sm font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-[15px]">
          {work.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">{work.summary}</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {work.genres.slice(0, 3).map((g) => (
            <span key={g} className="rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-900">
              {g}
            </span>
          ))}
          <span className="rounded bg-background-100 px-1.5 py-0.5 text-[11px] text-foreground-600">{work.status}</span>
        </div>
      </div>
    </Link>
  );
}